import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { PROMOS_URL } from './constant/BaseApiUrl';

export default class PromosService {
  submitPromos(payload, tab) {
    return axios.post(`${PROMOS_URL}${ApiKey.PROMOS}/${tab}`, payload);
  }

  submitSectionTitlePromos(payload) {
    return axios.put(`${PROMOS_URL}configurations/promos`, {
      titleType: payload?.typeEnum,
      value: payload?.value
    });
  }

  deletePromos(id, tab) {
    return axios.delete(`${PROMOS_URL}${ApiKey.PROMOS}/${tab}/${id}`);
  }
  getTopbarInfo() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/top-banners`);
  }
  getTopBannerHomePageInfo() {
    return axios.get(`${PROMOS_URL}${ApiKey.HOME_PAGE}/top-banner`, { metadata: { notRequiresToken: true } });
  }
  submitTopBanner(payload) {
    return axios.post(`${PROMOS_URL}${ApiKey.HOME_PAGE}/top-banner`, payload);
  }
  getBottomBannerHomePageInfo() {
    return axios.get(`${PROMOS_URL}${ApiKey.HOME_PAGE}/bottom-banner`, { metadata: { notRequiresToken: true } });
  }
  submitBottomBanner(payload) {
    return axios.post(`${PROMOS_URL}${ApiKey.HOME_PAGE}/bottom-banner`, payload);
  }
  getSidePromoInfo() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/side-promos`);
  }
  getSectionTitlePromo() {
    return axios.get(`${PROMOS_URL}configurations/promos`, { metadata: { notRequiresToken: true } });
  }
  getPromoBox() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/promo-boxes`, { metadata: { notRequiresToken: true } });
  }
  getFormPromo() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/form-promos`);
  }
  getSurfacePromos() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/surface-promos`, { metadata: { notRequiresToken: true } });
  }
  getAccordionPromos() {
    return axios.get(`${PROMOS_URL}${ApiKey.PROMOS}/accordion-promos`, { metadata: { notRequiresToken: true } });
  }
}
